export enum FooterTheme {
  BLUE = 'BLUE',
  RED = 'RED',
  OPAL = 'OPAL',
}
